import { render, staticRenderFns } from "./NotenausgabeSV.vue?vue&type=template&id=7ab46df2&"
import script from "./NotenausgabeSV.vue?vue&type=script&lang=js&"
export * from "./NotenausgabeSV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports